package org.hs_soft.runmynesto.domain.model.home.options.export.cash_reigster_gloabal_info

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("getAppConfig")
    val getAppConfig: GetAppConfig?=null, // AppConfig
    @SerialName("updateAppConfig")
    val updateAppConfig: GetAppConfig?=null, // AppConfig
    @SerialName("__typename")
    val typename: String?
)